export default __webpack_public_path__ + "static/polygon3-ddca1583f07b0b4ed348cf8ef4333c38.png";